<template>
  <AppBanner>
    <template #prepend>
      <CountryFlag :code="getVisaCountryIsoCode(product.country)" />
    </template>
    {{ tProductLabel(product.name, 'long') }}: 
    <PriceSpan :price="product.price" strong />
    <InfoIconTooltip v-if="product.note">
      {{ $tt(product.note) }}
    </InfoIconTooltip>
  </AppBanner>
</template>

<script setup lang="ts">
import { getVisaCountryIsoCode } from '~/helpers/visa-country';
import type { Product } from '~/types';

defineProps<{
  product: Product;
}>();

const { tProductLabel } = useLocalization();
</script>